import { render, staticRenderFns } from "./FuncionesGlobalesPantalla.vue?vue&type=template&id=640f661f&"
import script from "./FuncionesGlobalesPantalla.vue?vue&type=script&lang=ts&"
export * from "./FuncionesGlobalesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports